module.exports = __webpack_public_path__ + "img/login_back_1.6fa80450.svg";